module.exports = __webpack_public_path__ + "img/bannerbig3.dbcbb8bb.png";